/**
 * 股票市场类型枚举
 */
export enum StockMarketType {
  US = "US",
  HK = "HK",
}

/**
 * 市场模式枚举
 */
export enum MarketMode {
  STOCK = "stock",
  CRYPTO = "crypto",
}

/**
 * 主题市场类型（更细粒度）
 */
export type ThemeMarketType = "crypto" | "us-stocks" | "hk-stocks";

export enum ThemesScopeEnum {
  HeatMap = "HeatMap",
  HotSearch = "HotSearch",
  Recommend = "Recommend",
}

export enum ThemesSortFieldEnum {
  PRICE_CHANGE_24H = "PRICE_CHANGE_24H",
  MANUAL = "MANUAL",
}
